<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="qr-code-container" style="text-align: center">
        <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR Code" class="qr-image" />
        <div>{{ this.job.title }}</div>
        <div>{{ this.job.projectInfoText }}</div>
      </div>

      <footer class="footer-buttons">
        <div style="display: flex; gap: 10px">
          <b-button
            type="is-info"
            @click="downloadTraveler"
            icon-left="text-box-outline"
            :loading="exportingTask"
          >
            {{ $t('download_traveler') }}
          </b-button>

          <b-button @click="downloadQr" icon-left="file-png-box">{{
            $t('download_qr_code')
          }}</b-button>
        </div>

        <b-button label="Close" @click="onClose" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import QRCode from 'qrcode';
import client from '../../config/api';

export default {
  name: 'qr-code-viewer',

  props: {
    qrString: {
      type: String,
    },
  },

  computed: {
    job() {
      return this.$store.state.currentJob;
    },
  },

  data() {
    return {
      qrDataUrl: null,
      exportingTask: false,
    };
  },

  async mounted() {
    this.generateQr();
  },

  methods: {
    async generateQr() {
      try {
        this.qrDataUrl = await QRCode.toDataURL(this.job._id, {
          width: 900,
          margin: 1,
        });
      } catch (err) {
        console.error('QR generation failed:', err);
      }
    },
    downloadQr() {
      const link = document.createElement('a');
      link.href = this.qrDataUrl;
      link.download = `qr-code-${this.job._id}.png`;
      link.click();
    },

    async downloadTraveler() {
      try {
        this.exportingTask = true;
        const result = await client.get(`/job/traveler/${this.job._id}`);
        this.triggerDownload(result.data.downloadPath);
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: `Error exporting traveler job: ${this.this.job.title} - ${this.this.job.projectInfoText} `,
          position: 'is-top',
          type: 'is-danger',
        });
        console.error('Error exporting task:', error);
      } finally {
        this.exportingTask = false;
      }
    },

    triggerDownload(downloadLink) {
      const anchor = document.createElement('a');
      anchor.style.display = 'none';
      anchor.href = downloadLink;
      anchor.setAttribute('download', '');

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    },
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  justify-content: space-between;
}

.qr-image {
  width: 500px;
  height: 500px;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
